export default __webpack_public_path__ + "static/media/fastFood02.79aa6463.png";